import styled from "styled-components";

export const Asterisk = styled.span.attrs({ children: "*" })`
  margin-left: ${({ theme }) => theme.smallMargin};
`;
